<template>
  <td
    :class="classes"
    :colspan="colspan"
    :style="{
      display: hidden ? 'none' : '',
    }"
  >
    <template v-if="column.id === 'operationDate'">
      <div v-if="view === 'group-header'" class="d-flex align-items-center">
        {{ date.name }}

        <svg-icon
          v-if="extendable"
          class="operations-date__opener"
          :size="24"
          name="chevron-top-circled"
          color="primary"
          @click="$emit('toggle')"
        ></svg-icon>
      </div>
      <template v-else-if="view === 'operation'">
        {{ item.date }}
      </template>
    </template>

    <template v-else-if="column.id === 'transactionDate'">
      <template v-if="view !== 'group-header'">{{ item.created }}</template>
    </template>

    <template v-else-if="column.id === 'balanceStart'">
      <template v-if="view !== 'group-item'">{{ item.dayStartBalance.toLocaleString() }}</template>
    </template>

    <template v-else-if="column.id === 'salary'">
      {{ item.salary.toLocaleString() }}
    </template>

    <template v-else-if="column.id === 'dynamic'">
      {{ item.dynamic.toLocaleString() }}
    </template>

    <template v-else-if="column.id === 'bonus'">
      {{ item.bonus.toLocaleString() }}
    </template>

    <template v-else-if="column.id === 'penalty'">
      {{ item.penalty.toLocaleString() }}
    </template>

    <template v-else-if="column.id === 'amount'">
      <span
        :class="{
          'positive-number': item.amount > 0,
          'negative-number': item.amount < 0,
        }"
      >
        {{ item.amount.toLocaleString() }}
      </span>
    </template>

    <template v-else-if="column.id === 'balanceEnd'">
      <template v-if="view !== 'group-item'">{{ item.dayEndBalance.toLocaleString() }}</template>
    </template>

    <template v-else-if="column.id === 'author'">
      <template v-if="view !== 'group-header' && item.author">
        <worker-or-user :value="item.author" :without-link="!edit" />
      </template>
    </template>

    <template v-else-if="column.id === 'reason'">
      <template v-if="view !== 'group-header' && item.reason">
        {{ item.reason }}
        <div v-if="item.comment" class="operation-comment">
          <svg-icon name="comment" class="operation-comment__icon"></svg-icon>
          {{ item.comment }}
        </div>
      </template>
    </template>

    <template v-else-if="column.id === 'removalAuthor'">
      <template v-if="view !== 'group-header' && item.author">
        <worker-or-user :value="item.removalAuthor" :without-link="!edit" />
      </template>
    </template>

    <template v-else-if="column.id === 'removalDate'">
      <template v-if="view !== 'group-header' && item.author">
        {{ item.removalDate }}
      </template>
    </template>

    <template v-else-if="column.id === 'removalComment'">
      <template v-if="view !== 'group-header' && item.author">
        {{ item.removalComment }}
      </template>
    </template>

    <template v-else-if="column.id === 'actions'">
      <template v-if="operation">
        <router-link
          v-if="operation.calculation"
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Сохраненный расчет по филиалу ' + operation.calculation.filial + ' за ' + date.name,
            placement: 'top',
          }"
          target="_blank"
          :to="{
            name: 'save-calculation-production',
            query: {
              calc_id: operation.calculation.id,
            },
          }"
        >
          <svg-icon :size="16" name="calculator"></svg-icon>
        </router-link>

        <template v-else-if="canRemove">
          <c-button size="iconic" :icon="{ icon: 'trash', color: 'secondary' }" @click="$emit('remove')" />
        </template>
      </template>
    </template>

    <template v-else-if="column.id === 'restore'">
      <template v-if="operation">
        <c-button size="iconic" :icon="{ icon: 'restore',  }"  @click="$emit('restore')" />
      </template>
    </template>
  </td>
</template>

<script>
import CButton from "@/components/controls2/Button";
import SvgIcon from "@/components/svg-icon";
import WorkerOrUser from "@/components/user/worker-or-user";

export default {
  components: { SvgIcon, CButton, WorkerOrUser },
  props: ["column", "date", "operation", "edit", "canRemove"],

  computed: {
    extendable() {
      if (!this.date.resume) return false;
      return this.column.id === "operationDate";
    },
    hidden() {
      return this.operation && this.extendable;
    },
    extended() {
      return this.extendable && this.date.open;
    },
    colspan() {
      if (!this.extended) return 1;
      return this.date.operations.length + 1;
    },

    view() {
      if (this.extendable) return "group-header";

      if (this.operation && this.date.resume) return "group-item";

      return "operation";
    },

    item() {
      return this.operation || this.date.resume;
    },
    hasBonus() {
      return this.column.id === "bonus" && this.item.bonus > 0;
    },
    hasPenalty() {
      return this.column.id === "penalty" && this.item.penalty < 0;
    },

    classes() {
      return [
        "h-table__cell",
        (this.extended || this.view === "group-item") && "h-table__cell--header",
        this.column.className,
        this.extendable && "operations-date",
        this.extended && "operations-date--open",
        (this.hasBonus || this.hasPenalty) && "h-table__cell",
        this.hasBonus && "h-table__cell-positive",
        this.hasPenalty && "h-table__cell--negative",
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
};
</script>

<style lang="scss" scoped>
.operations-table {
  .operation-comment {
    margin-top: 6px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1.2;

    &__icon {
      margin-right: 8px;
      flex-shrink: 0;
    }
  }

  .operations-date {
    &__opener {
      transition: transform 250ms ease-in-out;
      transform: rotate(0);
      margin-left: 12px;
    }
    &--open {
      .operations-date__opener {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
